import * as Yup from "yup";
export const validationstation = (state) => {
  let validationSchema = {};
  return (validationSchema = Yup.object().shape({
    stationID: Yup.string().required("Enter Station ID"),
    name: Yup.string().required("Enter Station Name"),
    serialNumber: Yup.string().required("Enter Serial Number"),
    vendorName: Yup.string().required("Enter Vendor Name"),
    model: Yup.string().required("Enter Model"),
    address_line1: Yup.string()
      .max(30, "Must be 30 characters or less")
      .required("Enter Address 1"),
    address_line2: Yup.string()
      .max(30, "Must be 30 characters or less")
      .required("Enter Address 2"),
    country: Yup.object().required("Kindly select Country"),
    city: Yup.object().required("Kindly select City"),
    state: Yup.object().required("Kindly select State"),
    zipCode: Yup.number()
      .typeError("It doesn't look like a zip code")
      .positive("A zip code can't start with a minus")
      .integer("It can't include a decimal point")
      .required("Enter Your Zip Code"),
    // coordinates: Yup.object().shape({
    //   latitude: Yup.number().required("Enter Latitude"),
    //   longitude: Yup.number().required("Enter Longitude"),
    // }),
  }));
};
